<template>
    <div class="menu">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="">全部</el-menu-item>
            <el-menu-item index="1">订单待支付 <span style="color: red;" v-if="ordernum.order_status1_num != 0">{{
                ordernum.order_status1_num }}</span> </el-menu-item>
            <el-menu-item index="2">订单待确认 <span style="color: red;" v-if="ordernum.order_status2_num != 0">{{
                ordernum.order_status2_num }}</span> </el-menu-item>
            <el-menu-item index="3">订单处理中 <span style="color: red;" v-if="ordernum.order_status3_num != 0">{{
                ordernum.order_status3_num }}</span> </el-menu-item>
            <el-menu-item index="4">订单已生效 <span style="color: red;" v-if="ordernum.order_status4_num != 0">{{
                ordernum.order_status4_num }}</span> </el-menu-item>
        </el-menu>
        <div class="conten" v-loading="loading">
            <div class="index_search">
                <el-input placeholder="" v-model="queryParams.search_content" clearable @clear="getlist">
                    <template slot="append">
                        <div @click="getlist">
                            搜索
                        </div>
                    </template>
                </el-input>
            </div>
            <div class="asss" v-if="ulist.length != 0">
                <div class="cont_tit">
                    <div style="text-align: center;flex: 1;">订单信息</div>
                    <div class="c_r">
                        <div class="i">金额</div>
                        <div class="i">交易状态</div>
                        <div class="i">交易操作</div>
                    </div>
                </div>
                <div>
                    <div class="ove" id="outerDiv">
                        <div class="list_item" v-for="(item, index) in ulist" :key="index">
                            <div class="item_tit">
                                <div class="tit_l">
                                    <img :src="item.avatar" alt="" srcset="">
                                    <div class="tit_name">{{ item.nickname }}</div>
                                </div>
                                <img @click="openTim(item)" class="ricon" src="@/assets/user/uxx.png" alt="" srcset="">
                            </div>
                            <div class="list_item-cont_tit">
                                <div class="item_l">
                                    <img src="@/assets/user/u1.png" alt="">
                                    <div class="itext">订单编号：{{ item.order_no }}</div>
                                    <div v-if="item.attachment_url || item.attachment_url2" class="orderattachment" @click="previewfile(item.attachment_url,item.attachment_url2)">订单详情+物流单</div>
                                </div>
                                <div class="c_r">
                                    <div class="i i1">
                                        <div>￥{{ item.order_money }}</div>
                                    </div>
                                    <!-- "order_status": 7, //	订单状态:1=待支付,2=待发货,3=待收货,4=已收货,5=已取消 -->
                                    <!-- refund_status 退款状态:1=未申请,2=待审核,3=通过,4=驳回 -->
                                    <div class="i i1">
                                        <div v-if="item.order_status == 1 && item.refund_status == 1">订单待支付</div>
                                        <div v-else-if="item.order_status == 2">订单待确认</div>
                                        <div v-else-if="item.order_status == 3">订单处理中</div>
                                        <div v-else-if="item.order_status == 4">订单已生效</div>
                                        <div v-else-if="item.order_status == 5 && item.refund_status == 1">已取消</div>
                                        <div v-else-if="item.order_status != 0 && item.refund_status == 2">退款中</div>
                                        <div v-else-if="item.order_status != 0 && item.refund_status == 3">已退款</div>
                                    </div>
                                    <div class="i i1">
                                        <div>
                                            <div class="btn1" v-if="item.order_status == 1" @click="nowfukuan(item)">
                                                立即付款
                                            </div>
                                            <div class="btn1"
                                                v-if="item.order_status == 3 && item.refund_status != 2"
                                                @click="handleSh(item)">确认订单</div>
                                            <div class="btn2" v-if="item.order_status == 1" @click="outOrder(item)">取消订单
                                            </div>
                                            <div class="btn2"
                                                v-if="item.refund_status == 1 && (item.order_status == 3 || item.order_status == 2)"
                                                @click="shenqtuikuan(item)">
                                                申请退款</div>

                                            <div class="btn2" v-if="item.refund_status != 1" @click="gotklist">
                                                查看退款</div>
                                            <div class="btn2" v-if="item.order_status == 5 && item.refund_status == 1"
                                                @click="dlelist(item)">
                                                删除订单</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="inote">
                                <div style="width: 40%;">
                                    <div class="text-container">
                                        <!-- 文本展示模式 -->
                                        <div  class="text-display" :title="item.order_note">
                                            <span>备注：</span>{{item.order_note}}
                                        </div>
                                    </div>
                                </div>

                                <div class="itime">
                                    <div> 创建时间：{{ item.createtime | formatDate }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pagination">
                        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.page"
                            :limit.sync="queryParams.limit" @pagination="getlist" />
                    </div>
                </div>
            </div>
        </div>
        <div class="k" v-if="nolist">
            <div>
                <img src="@/assets/user/k.png" alt="" srcset="">
                <div class="text">暂无订单</div>
            </div>
        </div>
        <!-- 立即付款 -->
        <el-dialog title="微信支付" class="dialogstim" :visible.sync="popup.fukuanpop" width="500px">
            <div class="fukuanpop">
                <div class="imgs">
                    <img :src="popup.fukuanUrl" alt="">
                </div>
                <div class="texts">请尽快支付，超时将自动取消订单</div>
            </div>
        </el-dialog>
        <!-- 申请退款弹窗 -->
        <el-dialog class="dialogs" title="申请退款" :visible.sync="popup.tuikuanpop" width="522px">
            <div class="tkpop">
                <div class="tit">
                    退款信息
                </div>
                <div class="tkOne">
                    <div class="tflex">
                        <img :src="nowinfo.avatar" alt="">
                        <div>{{ nowinfo.nickname }}</div>
                    </div>
                    <div class="dd">订单编号：{{ nowinfo.order_no }}</div>
                </div>
                <div class="tkTwo">
                    <div class="jk">
                        <div>
                            退款金额：￥
                        </div>
                        <div>
                            <InputConfim v-model="nowinfo.order_money"></InputConfim>
                        </div>
                    </div>
                    <div class="ts">
                        申请通过后退回至原账户
                    </div>

                    <div class="tk">
                        <div>
                            退款原因：
                        </div>
                        <div style="flex:1">
                            <input v-model="tkparams.refund_reason" type="text" placeholder="请填写" />
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="popup.tuikuanpop = false">取 消</el-button>
                <el-button type="primary" @click="handleTkuan">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog class="dialogstim" :visible.sync="popup.showTim" width="1122px">
            <TimView v-if="popup.showTim" :chatID="chatID" :openNum="1"></TimView>
        </el-dialog>
        <FilePreviewDialog
            :files="prefiles"
            :visible="isDialogVisible"
            :initialIndex = "preindex"
            title="订单详情"
            @close="closepreview"
        />
    </div>
</template>

<script>
import TimView from '@/components/TimView/index.vue'
import InputConfim from '@/components/inputConfim/index.vue'
import FilePreviewDialog from '@/components/FileView/FilePreviewDialog.vue';
import { getUserOrderList, userCancelOrder, userOrderNum, userApplyRefund, receiveOrder, userDelOrder } from '@/api/index.js'
export default {
    components: { TimView, InputConfim, FilePreviewDialog },
    name: '',
    data() {
        return {
            activeIndex: '',
            total: 0,
            nolist: false,
            queryParams: {
                page: 1,
                limit: 10,
                status: '', //1=待支付,2=待发货,3=待收货,4=已收货,''=全部
                search_content: ''
            },
            loading: false,
            ulist: [],
            popup: {
                fukuanpop: false,
                fukuanUrl: '',
                showTim: false, //客服弹窗
                tuikuanpop: false,
            },
            chatID: 0,//聊天
            ordernum: {},
            nowinfo: {}, //退款展示信息
            tkparams: {
                order_id: '',
                refund_money: '',
                refund_reason: '',
            },
            isDialogVisible: false,
            prefiles:[],
            preindex:0

        }
    },
    computed: {
        isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        }
    },
    mounted() {
        this.getlist()

    },
    methods: {
        //打开聊天
        openTim(item) {
            if (this.isMobile) {
                this.$dataConver.gopage(item.supplier_user_id)
                return
            }
            this.popup.showTim = true
            this.chatID = item.supplier_user_id
        },
        //搜索
        handleSelect(e) {
            this.queryParams.status = e
            this.queryParams.page = 1
            this.getlist()
        },
        getlist() {
            this.loading = true
            getUserOrderList(this.queryParams).then(res => {
                if (res.code == 1) {
                    this.ulist = res.data.list
                    this.total = res.data.total
                    let total = Math.ceil(res.data.total / this.queryParams.limit);
                    this.nolist = total == 0
                    this.loading = false
                    if (res.data.list.length != 0) {
                        this.$nextTick(() => {
                            document.getElementById('outerDiv').scrollTop = 0
                        });
                    }
                    userOrderNum().then(ress => {
                        this.ordernum = ress.data
                    })
                }
            })
        },
        //立即付款
        nowfukuan(item) {
            this.popup.fukuanUrl = item.pay_code
            this.popup.fukuanpop = true
        },
        //取消订单
        outOrder(item) {
            this.$confirm('确定要取消当前订单吗？', '提示', {
                confirmButtonText: '确定',
                type: 'warning'
            }).then(() => {
                userCancelOrder({ order_id: item.id }).then(res => {
                    if (res.code == 1) {
                        this.$modal.msgSuccess(`订单已取消`);
                        this.queryParams.page = 1
                        this.getlist()
                    }
                })
            }).catch(() => { });
        },
        //申请退款弹窗
        shenqtuikuan(item) {
            this.nowinfo = {
                ...item,
                origin_money:item.order_money
            }
            this.popup.tuikuanpop = true
        },
        //申请退款确认
        handleTkuan() {
            this.tkparams.order_id = this.nowinfo.id
            this.tkparams.refund_money = this.nowinfo.order_money
            if (this.tkparams.refund_money == '' || this.tkparams.refund_reason == '') {
                this.$modal.msgError(`请完整填写退款信息`);
                return
            }
            let num = parseFloat(this.tkparams.refund_money)
            if(isNaN(num)) {
                this.$modal.msgError(`请填写正确的金额`);
                return
            }

            if(num > this.nowinfo.origin_money){
                this.$modal.msgError(`申请金额不能大于订单金额`);
                return
            }

            userApplyRefund(this.tkparams).then(res => {
                if (res.code == 1) {
                    this.popup.tuikuanpop = false
                    this.$modal.msgSuccess(`退款已申请`);
                    this.queryParams.page = 1
                    this.getlist()
                }
            })
        },
        //跳转退款订单
        gotklist() {
            this.$store.commit('SetNowIndex', 1)
            this.$router.push({ path: '/tkgl' }).catch(err => { })
        },
        //确认收货
        handleSh(item) {
            receiveOrder({ order_id: item.id }).then(res => {
                if (res.code == 1) {
                    this.$modal.msgSuccess(`收货已确认`);
                    this.queryParams.page = 1
                    this.getlist()
                }
            })
        },
        dlelist(item) {
            this.$confirm('确定要删除当前订单吗？', '提示', {
                confirmButtonText: '确定',
                type: 'warning'
            }).then(() => {
                userDelOrder({ order_id: item.id }).then(res => {
                    if (res.code == 1) {
                        this.$modal.msgSuccess(`订单已删除`);
                        this.queryParams.page = 1
                        this.getlist()
                    }
                })
            }).catch(() => { });
        },
        async previewfile(url1, url2){
            this.prefiles = []
            if(url1){
                this.prefiles.push({url:url1})
            }
            if(url2){
                this.prefiles.push({url:url2})
            }
            this.isDialogVisible = true
        },
        closepreview(){
            this.isDialogVisible = false;
        }
    },
}
</script>
<style lang='scss' scoped>
.dialogstim ::v-deep .el-dialog__body {
    padding: 12px 0px 0px 0px !important;
}

.dialogstim ::v-deep .el-dialog__header {
    padding: 20px;
}

.menu {
    background-color: #fff;
}

.el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 2px solid #FFDB0C;
    font-size: 16px;
}

.el-menu--horizontal>.el-menu-item {
    font-size: 14px;
}

.el-dropdown-menu__item,
.el-menu-item {
    padding: 0px 50px;
}

.conten {
    box-sizing: border-box;
    padding: 10px 10px 0px 10px;

    .index_search {
        display: flex;
        width: 560px;
        height: 36px;

        ::v-deep .el-input-group__append,
        .el-input-group__prepend {
            background-color: #FFDB0C;
            color: #000000;
            cursor: pointer;
        }

    }

    .cont_tit {
        display: flex;
        height: 38px;
        background: #F7F8FA;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #DEDEDE;
        align-items: center;
        margin: 10px 0px 6px 0px;
        line-height: 38px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #000000;
        justify-content: space-between;

        .c_r {
            display: flex;

            .i {
                width: 120px;
                text-align: center;
            }
        }
    }

    .ove {
        height: 500px;
        overflow: auto;

        &::-webkit-scrollbar {
            width: 6px;
            height: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: rgba(144, 147, 153, 0.3);
            cursor: pointer;
            border-radius: 4px;
        }

        .list_item {
            background: #FFFFFF;
            border-radius: 4px;
            border: 1px solid #DEDEDE;
            margin-bottom: 6px;

            .item_tit {
                display: flex;
                justify-content: space-between;
                align-items: center;
                background-color: #F7F8FA;
                padding: 6px 9px;
                box-sizing: border-box;

                .ricon {
                    width: 16px;
                    height: 16px;
                    cursor: pointer;
                }

                .tit_l {
                    display: flex;
                    align-items: center;

                    img {
                        width: 26px;
                        height: 26px;
                        border-radius: 4px;
                        border: 1px solid #DEDEDE;
                    }

                    .tit_name {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 500;
                        font-size: 14px;
                        color: #000000;
                        line-height: 16px;
                        margin-left: 6px;
                    }
                }
            }

            .list_item-cont_tit {
                display: flex;
                align-items: center;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #000000;
                justify-content: space-between;
                height: 76px;
                border-bottom: 1px solid #DEDEDE;
                align-items: center;

                .c_r {
                    display: flex;
                    align-items: center;
                    height: 76px;

                    .i1 {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    .i {
                        width: 120px;
                        text-align: center;
                        border-left: 1px solid #DEDEDE;
                        height: 76px;
                    }

                    .btn1 {
                        width: 74px;
                        height: 30px;
                        background: #FFDB0C;
                        border-radius: 6px 6px 6px 6px;
                        text-align: center;
                        line-height: 30px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 500;
                        font-size: 14px;
                        color: #000000;
                        margin-bottom: 6px;
                        cursor: pointer;
                    }

                    .btn2 {
                        width: 74px;
                        height: 30px;
                        border-radius: 6px 6px 6px 6px;
                        text-align: center;
                        line-height: 30px;
                        border: 1px solid #DEDEDE;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 500;
                        font-size: 14px;
                        color: #000000;
                        cursor: pointer;
                    }

                    
                }

                .item_l {
                    display: flex;
                    align-items: center;
                    margin-left: 15px;

                    .itext {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 500;
                        font-size: 14px;
                        color: #000000;
                        margin-left: 15px;

                    }
                    .btn2 {
                        width: 74px;
                        height: 30px;
                        border-radius: 6px 6px 6px 6px;
                        text-align: center;
                        line-height: 30px;
                        border: 1px solid #DEDEDE;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 500;
                        font-size: 14px;
                        color: #000000;
                        cursor: pointer;
                        margin-left: 10px;
                    }

                    .orderattachment {
                        width: 128px;
                        height: 30px;
                        border-radius: 6px 6px 6px 6px;
                        text-align: center;
                        line-height: 30px;
                        border: 1px solid #DEDEDE;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 500;
                        font-size: 14px;
                        color: #000000;
                        cursor: pointer;
                        margin-left: 10px;
                    }

                }
            }

            .itime {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #000000;
                line-height: 16px;
                padding: 13px;
                box-sizing: border-box;
                display: flex;
                align-items: center;

                div {
                    margin-right: 10px;
                }
            }
            .inote {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #000000;
                line-height: 16px;
                padding: 4px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                border-bottom: 1px solid #DEDEDE;

                .text-container {
                    width: 100%;
                    margin-top: 5px;
                    .text-display {
                        width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        cursor: text;
                        border: 1px solid transparent;
                        align-items: center;
                    }

                    .text-display:hover {
                        background-color: #f5f5f5;
                    }
                }
            }
        }


    }


}

.pagination {
    text-align: right;

    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #FFDB0C;
    }

    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #000000;
    }

    .pagination-container {
        padding: 10px 10px 0px 10px;
    }
}

.k {
    text-align: center;
    height: 600px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        width: 224px;
        height: 224px;
    }

    .text {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #ADAAAA;
        margin-top: 20px;
    }
}


.fukuanpop {
    img {
        display: block;
        width: 300px;
        height: 300px;
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #DEDEDE;
        margin: 10px auto;
    }

    .texts {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #ADAAAA;
        text-align: center;
        margin-bottom: 40px;
    }
}

.tkpop {
    .tit {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 20px;
        color: #000000;
        line-height: 23px;
    }

    .tkOne {
        margin-top: 20px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #DEDEDE;
        padding: 13px;
        box-sizing: border-box;

        .tflex {
            display: flex;
            align-items: center;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #000000;

            img {
                width: 26px;
                height: 26px;
                margin-right: 8px;
                border-radius: 4px;
            }
        }

        .dd {
            margin-top: 10px;
        }


    }

    .tkTwo {
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #DEDEDE;
        padding: 26px 19px;
        box-sizing: border-box;
        margin-top: 10px;

        .jk {
            display: flex;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #000000;
            align-items: center;
        }

        .jk::before {
            content: '*';
            color: red;
        }

        .ts {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #ADAAAA;
            border-bottom: 1px solid #DEDEDE;
            margin: 10px 0px;
            padding-bottom: 10px;
        }

        .tk {
            display: flex;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #000000;
            align-items: center;

            input {
                width: 100%;
                font-weight: 500;
                font-size: 16px;
                color: #000000;
                border: none;
            }
        }

        .tk::before {
            content: '*';
            color: red;
        }
    }

}
</style>